class VideoSlider extends HTMLElement {
  constructor() {
    super();
    this.initializeSwiper();
  }

  initializeSwiper() {
    const swiper = new Swiper('.m-video-slider__wrapper', {
      slidesPerView: 'auto',
      spaceBetween: 30,
      grabCursor: true,
      resistance: true,
      resistanceRatio: 0.5,
      touchRatio: 1,
      touchAngle: 45,
      touchEventsTarget: 'wrapper', // Asegura que los eventos táctiles se detecten en el wrapper
      preventClicks: true, // Evita que los clics interfieran con el desplazamiento
      preventClicksPropagation: true,
      cssMode: false, // Desactiva el scroll en CSS para mejorar la experiencia táctil
      slideToClickedSlide: true,
      watchSlidesProgress: true,
      breakpoints: {
        320: {
          slidesPerView: 1.2,
          spaceBetween: 10,
          centeredSlides: true,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 30,
        },
      },
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new VideoSlider();
});

customElements.define('video-slider', VideoSlider);
